module.exports = __webpack_public_path__ + "img/2@3x.6ddb49c3.png";